import { useEffect, useState } from 'react';

// LOT 72 · le logo de l'établissement n'est chargé qu'une fois : toutes les images partagent la même copie
const copies = new Map();
const partage = (src) => !!src && (src.includes('/public/logo/') || src.includes('/static/logos/'));  // LOT 77 · un seul chargement du logo par page

const charger = (brut) => {
  const src = new URL(brut, window.location.href).href;
  if (!copies.has(src)) copies.set(src, fetch(src).then((r) => (r.ok ? r.blob() : Promise.reject())).then((b) => URL.createObjectURL(b)).catch(() => src));
  return copies.get(src);
};

export const useImageUnique = (src) => {
  const [url, setUrl] = useState(() => (partage(src) ? null : src));
  useEffect(() => {
    if (!partage(src)) { setUrl(src); return undefined; }
    let vivant = true;
    charger(src).then((u) => { if (vivant) setUrl(u); });
    return () => { vivant = false; };
  }, [src]);
  return url;
};
